export default "__VITE_ASSET__Bu3$uIwv__"